import { render } from "./LotteryWinner.vue?vue&type=template&id=61b5055a&scoped=true"
import script from "./LotteryWinner.vue?vue&type=script&lang=js"
export * from "./LotteryWinner.vue?vue&type=script&lang=js"

import "./LotteryWinner.vue?vue&type=style&index=0&id=61b5055a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b5055a"]])

export default __exports__